import { render, staticRenderFns } from "./form13.vue?vue&type=template&id=20294f61&scoped=true&"
import script from "./form13.vue?vue&type=script&lang=js&"
export * from "./form13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20294f61",
  null
  
)

export default component.exports